export default __webpack_public_path__ + "static/media/two.c265b767.jpg";